var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyplans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.641,
    viewBox: "0 0 16 11.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-6.08 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17133",
    "data-name": "Path 17133",
    d: "M20.172,17.5H7.988A1.908,1.908,0,0,0,6.08,19.408v7.824a1.908,1.908,0,0,0,1.908,1.908H20.172a1.908,1.908,0,0,0,1.908-1.908V19.408A1.908,1.908,0,0,0,20.172,17.5ZM7.988,18.645H20.172a.763.763,0,0,1,.763.763v5.416H7.225V19.408a.763.763,0,0,1,.763-.763ZM20.172,28H7.988a.763.763,0,0,1-.763-.763V25.969h13.71v1.263A.763.763,0,0,1,20.172,28Zm-5.4-7.143a.573.573,0,0,1,.573-.573H18a.573.573,0,0,1,0,1.145H15.34A.573.573,0,0,1,14.767,20.853Z",
    fill: "#ff6036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyplans);
export default __webpack_public_path__ + "static/media/My plans.74485a4e8813404978110f1dd2bd0b2c.svg";
export { ForwardRef as ReactComponent };